import { worker_script } from "./worker";
import { HB_ACK } from '../appConstants';

const WS_CLOSE_BY_CLIENT = 1000;
const WS_CLOSED = 3000;
const WS_RECONNECTION_FAILED = 3001;

class Socket {
    retries = 0;
    intervals = new Worker(worker_script);
    websocket = null;
    
    resetSocket() {
        this.intervals.postMessage("resetTimers");
        this.websocket.close(WS_CLOSE_BY_CLIENT);

        // close and delete worker threads
        this.intervals.terminate();
    }

    getSocket() {
        return this.websocket;
    }
    
    reconnect = (ws, dispatch, websocket, callOnOpen, callOnMessage, callOnDisconnect, callOnReconnect) => {
        // close previous connection before starting new
        websocket.close(WS_RECONNECTION_FAILED, 'reconnection failed');
        callOnReconnect(dispatch);
        this.websocket=null;
        this.connectSocket(ws, dispatch, callOnOpen, callOnMessage, callOnDisconnect, callOnReconnect);
    }
    
    connectSocket = (ws, dispatch, callOnOpen = () => {}, callOnMessage = () => {}, callOnDisconnect = () => {}, callOnReconnect = () => {}) => {
        console.log(' this.websocket ',this.websocket)
         this.websocket = new WebSocket(ws.url, ws.params);
         this.websocket.onopen = () => {
            const [sendHeartbeat, updateProximity] = callOnOpen();
            this.intervals.postMessage("resetTimers");
            
            // send initial HB
            sendHeartbeat && sendHeartbeat(this.websocket);

            this.intervals.postMessage("start");
            this.intervals.onmessage = (msg) => {
                if (msg.data === "Send heartbeat") {
                    if (this.websocket.readyState === this.websocket.OPEN) {
                        sendHeartbeat && sendHeartbeat(this.websocket);
                        updateProximity && updateProximity(dispatch);
                    } else {
                        this.reconnect(ws, dispatch, this.websocket, callOnOpen, callOnMessage, callOnDisconnect, callOnReconnect);
                    }
                } else if (msg.data === 'terminate') {
                    this.websocket.close(WS_CLOSED, 'closed by user');
                    callOnDisconnect(dispatch);
                } else if (msg.data === 'reconnect') {
                    // this.websocket.close(WS_CLOSED, 'closed by user');
                    this.reconnect(ws, dispatch, this.websocket, callOnOpen, callOnMessage, callOnDisconnect, callOnReconnect);
                }
            };
        };
        this.websocket.onmessage = (event) => {
            const msgData=JSON.parse(event.data);
            if(msgData.BCM === HB_ACK || msgData.BCM === '30') {
                this.intervals.postMessage("resetTimeout");
            } else {
                callOnMessage(dispatch, event);
            }
        };

        // onerror handling is not required as ws is closed automatically after error
        this.websocket.onclose = (event) => {
            // if not closed by client (logout)
            if (event.code !== 1000) {
                this.intervals.postMessage("resetTimers");
                this.intervals.postMessage("reconnect");
            }

            this.intervals.onmessage = (msg) => {
                const [sendHeartbeat, updateProximity] = callOnOpen();
                if (msg.data === "Send heartbeat") {
                    if (this.websocket.readyState === this.websocket.OPEN) {
                        sendHeartbeat && sendHeartbeat(this.websocket);
                        updateProximity && updateProximity(dispatch);
                    } else {
                        this.reconnect(ws, dispatch, this.websocket, callOnOpen, callOnMessage, callOnDisconnect, callOnReconnect);
                    }
                } else if (msg.data === 'terminate') {
                    this.websocket.close(WS_CLOSED, 'closed by user');
                    callOnDisconnect(dispatch);
                }
            }
        }
        return this.websocket;
    }
}

export default Socket;